import React, { createContext, useContext, useMemo } from 'react';
import { usePlanner as useExistingPlanner } from '../../../contexts/PlannerContext';

const UIPlannerContext = createContext(null);

export function PlannerProvider({ children }) {
  const existing = useExistingPlanner();
  const value = useMemo(() => ({
    tasks: existing?.events || [],
    loading: false,
    error: null,
    refresh: () => {},
    // UI-only helpers; call existing update methods when possible
    moveTaskToStatus: (task, status) => {
      if (existing?.updateEventPatch) {
        return existing.updateEventPatch(task.id, { status });
      }
      console.warn('moveTaskToStatus called but updateEventPatch not available');
    },
    updateTaskUIState: (taskId, patch) => {
      if (existing?.updateEventPatch) {
        return existing.updateEventPatch(taskId, patch);
      }
      console.warn('updateTaskUIState called but updateEventPatch not available');
    },
    filterTasks: (predicate) => {
      const list = existing?.events || [];
      return typeof predicate === 'function' ? list.filter(predicate) : list;
    },
    addGeneratedTasks: (tasksArray) => {
      if (Array.isArray(tasksArray) && tasksArray.length > 0) {
        existing?.addTasks?.(tasksArray);
      }
    },
    updateTask: (taskId, patch) => {
      if (existing?.updateEventPatch && taskId) {
        return existing.updateEventPatch(taskId, patch);
      }
      console.warn('updateTask called but updateEventPatch not available');
      return undefined;
    },
  }), [existing]);

  return (
    <UIPlannerContext.Provider value={value}>{children}</UIPlannerContext.Provider>
  );
}

export function usePlanner() {
  const ctx = useContext(UIPlannerContext);
  if (!ctx) throw new Error('usePlanner must be used within UI PlannerProvider');
  return ctx;
}
